import { z } from "zod";
import { passportStableIdSchema } from "./passport-catalogue.js";
import { observationProtocolResultSchema } from "./observation-protocol.js";
import { behaviourObservationSchema } from "./passport-progress.js";

const employeeStampCommandSchema = z
  .object({ employeeId: z.string().min(1), stampId: passportStableIdSchema })
  .strict();

export const passportCommandSchema = z.discriminatedUnion("type", [
  employeeStampCommandSchema.extend({ type: z.literal("stamp_assessment_started") }),
  employeeStampCommandSchema.extend({
    type: z.literal("stamp_assessment_completed"),
    answers: z.array(z.number().int().nonnegative()),
  }),
  employeeStampCommandSchema.extend({
    type: z.literal("stamp_learning_started"),
    resourceId: passportStableIdSchema,
  }),
  employeeStampCommandSchema.extend({
    type: z.literal("stamp_learning_completed"),
    resourceId: passportStableIdSchema,
  }),
  employeeStampCommandSchema.extend({
    type: z.literal("stamp_practice_evidence_submitted"),
    source: z.string().trim().min(2).max(200),
    context: z.string().trim().min(2).max(1_000),
  }),
  employeeStampCommandSchema.extend({
    type: z.literal("stamp_observation_requested"),
    context: z.string().trim().min(2).max(1_000),
  }),
  employeeStampCommandSchema.extend({ type: z.literal("stamp_submitted_for_review") }),
  employeeStampCommandSchema.extend({
    type: z.literal("stamp_demo_practice_awaiting_validation"),
  }),
  employeeStampCommandSchema.extend({
    type: z.literal("stamp_supervisor_decision"),
    decision: z.enum(["confirm", "keep", "return"]),
    observations: z.array(behaviourObservationSchema),
    observationProtocol: observationProtocolResultSchema.optional(),
    feedback: z.string().trim().max(1_000).optional(),
  }),
]);

export type PassportCommand = z.infer<typeof passportCommandSchema>;
